import {Component, Output, Input, EventEmitter, OnInit, Inject, ViewChild} from '@angular/core';
import { FileToDownload } from '../model/file-to-download';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {FileSizeConverter} from '../model/file-size-converter';
import { Project } from '../model/project';
import {DOCUMENT} from '@angular/common';
import {ServerAddress} from '../util/server-address';
import {GenericModalComponent} from '../modal/generic-modal.component';

@Component({

    selector: 'add-file-to-download-dialog',
    styles: [
        `
    .modal-dialog {
        width: 20%;
        margin:  auto;
    }
    .borderGray{
        border: 1px solid #ccc;
    }

    .borderRed{
        border: 1px solid red;
    }
    .fileWindow{ height:40px; margin-top:-5px;}
    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        height:61px;
    }
    .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}

    /*new css*/

    .modal-title{margin-top: -5px;}
    .closeBtnH4{margin-top:-5px;margin-right: -8px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .led{width:22px;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modalBodyContainer{
        padding-left: 3px;
        padding-right: 3px;
    }

    .modal-footer{background-color: #ECE8E5;}
    .modal-body {
        width: 100%;
        padding: 0;
        overflow-y: auto;
        background-color:#ECE8E5;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-header {
        height:56px;
    //background-color: #0064FE;
        background-image: url("../../assets/images/headerBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-content {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        background-color: #0064FE;
        padding-bottom: 3px;
    }

    .closeX {
        color: white;
        size: 25px;
    }

    .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
    }

    /* .btn-outline-danger:hover {
         width: 32px;
         background-image: url("../../../assets/images/closeBtnHovered.png");
     }*/

    .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

    .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}
        `
    ],
    template: `
<div class="modal" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;" tabindex="1" role="dialog">
    <div class="modal-dialog"  role="document" *ngIf="fileToDownload != null">
        <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <img class="fileWindow" src="../../assets/images/fileUpload.png">
              <h4 class="modal-title">Add File</h4>
                <!--<button (click)="hideDialog()" type="button" class="close">&times;</button>-->
                <!--<button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="hideDialog()">
                  <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
                </button>-->

                <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                    <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                </button></h4>
            </div><div class="modalBodyContainer">
                <div class="modal-body">
                        <div class="row" style="margin-top:20px;margin-right: 10px;margin-left: 10px;">
                            <input type="file" class="form-control" name="single" ng2FileSelect [uploader]="uploader" /><br/>
                            <table><tr *ngFor="let item of uploader.queue">
                                <!--<td><strong>{{ item?.file?.name }}</strong></td> -->
                                <td *ngIf="uploader.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                            </tr></table>
                            <!--<button type="button" class="btn btn-success btn-s"
                                    (click)="uploader.queue.pop().upload()" [disabled]="!uploader.getNotUploadedItems().length">
                                <span class="glyphicon glyphicon-upload"></span> Upload
                            </button>-->
                        </div>
                </div>
                <!-- footer-->
                <div class="modal-footer ">
                    <button (click)="newFileToDownload()" class="btn btn-primary clickable hand" id="submit" type="submit"><span style="margin-right: 10px;"><i class="fas fa-save"></i></span> {{'save'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<generic-info-modal  [hide]="_hideInfoModal"  (OkClick)="onOk()"></generic-info-modal>
     `
})
export class AddFileToDownloadComponent implements OnInit {
    @Input() definedTerminalType:number;
    @Input() hide = true;
    @Input('filesToDownload') fileToDownload:Array<FileToDownload>;
    @Input() project:Project;
    @Output('on-new-file-to-download') onNewFileToDownload: EventEmitter<any> = new EventEmitter();
    @Output('on-cancel-file-to-download') onCancelFileToDownload: EventEmitter<any> = new EventEmitter();
    @Output() ErrorUpload:EventEmitter<any> = new EventEmitter();
    @ViewChild (GenericModalComponent) protected genericModal:GenericModalComponent;
    protected uploader:FileUploader;

    private _file: File;
    private _sizeConverter: FileSizeConverter;


    private _fic: FileToDownload;
    _hideInfoModal = true;

    constructor( @Inject(DOCUMENT) public document) {
       console.log(document.location.origin);
    }

    ngOnInit(): void {
        this.uploader = new FileUploader({
            url:ServerAddress.getInstance().getValue()+'upload-project-file',
            headers: [{name:'Accept', value:'application/json'}],
            autoUpload: true,
            method:'POST',
            authToken:localStorage.getItem('Authorization')
        });
        this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
        this.uploader.onBeforeUploadItem = (item) => {
            if(item._file.name==='questionnaire.json' || item._file.name==='terminal.json') {
                this.uploader.removeFromQueue(item);
                item.remove();
            }
            item.withCredentials = false;



        };
        this.uploader.onCompleteItem = (item, response, status, headers) => {
            if(item._file.name==='questionnaire.json' || item._file.name==='terminal.json') {
                this.genericModal.defineModal('You cannot upload questionnaire.json or terminal.json. Those must be defined using the proper web interfaces.','File Uploader',250);
                this._hideInfoModal = false;
            }
        };


        // need to change this later with proper project terms
        this.uploader.onBuildItemForm = (item, form) => {


            item.formData =  [{ projectID:this.project.id, questionnaireID:this.project.questionnaires[0].id, terminalID:this.definedTerminalType}];
            form.append('projectID', this.project.id);
            form.append('questionnaireID', this.project.questionnaires[0].id);
            form.append('terminalID', this.definedTerminalType);
        };
    }

    onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        const data = response; // success server response
        console.log(data);
        if(this.fileToDownload !=null) {
            this._fic = new FileToDownload();
            this._fic.src = item._file.name;

            // this._fic.timestamp = item._file.lastModifiedDate;
            this._sizeConverter = new FileSizeConverter(item._file.size);
            this._sizeConverter.convertBytes();

            this._fic.size = item._file.size; // this._sizeConverter.getSize(); note: On utilise la taille en bytes
            this._fic.unit = 'Bytes';


            // The fileToDownload array is used to show later the files that were uploaded to the server
            // Avoid having duplicates and allow updated version of the existing file
            if (this.fileToDownload.length === 0) {
                this.fileToDownload.push(this._fic);
            } else {
                for (let i = 0; i < this.fileToDownload.length; i++) {
                    if (this.fileToDownload[i].src === this._fic.src) {
                        this.fileToDownload[i] = this._fic;
                    } else {
                        this.fileToDownload.push(this._fic);
                    }
                    break;
                }
            }
        }


    }

    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        const error = response; // error server response
        console.log(error);
        this.ErrorUpload.emit('An error occurred while uploading file.\n'+response);
    }


    hideDialog() {
        this._file = null;
        this.onCancelFileToDownload.emit();
    }

    newFileToDownload() {
        this.uploader.clearQueue();
        console.log(JSON.stringify(this.fileToDownload));
        if (this.fileToDownload.length > 0) {
            this._file = null;
            this.onNewFileToDownload.emit(this.fileToDownload);
        }
    }

    onOk() {
        this._hideInfoModal = true;

        this.genericModal.toggleModal();
    }
}
